import { FC } from "react"

import { Box, Stack } from "@mui/material"
import { useAppSelector } from "hooks/store"
import AsideNav from "layout/asideNav"
import Header from "layout/header"
import { useTranslation } from "react-i18next"
import { Outlet } from "react-router"
import { selectUser } from "store/auth/auth.selectors"
import { checkSubscription } from "utils/api"

import { ContentBox, SkipLink } from "./BaseLayout.styles"

interface IProps {
  compactTop?: boolean
}

const BaseLayout: FC<IProps> = ({ compactTop }) => {
  const { t } = useTranslation()
  const userInfo = useAppSelector(selectUser)

  return (
    <Box
      sx={{
        filter:
          !checkSubscription(userInfo) && userInfo !== null
            ? "blur(5px)"
            : "blur(0px)",
        pointerEvents: checkSubscription(userInfo) ? "all" : "none",
      }}
    >
      <SkipLink
        href="#main-content"
        onClick={() => document.getElementById("main-content")?.focus()}
      >
        {t("layout.skipToMainContent")}
      </SkipLink>
      <Box display="flex">
        <AsideNav />
        <Stack flexGrow="1" minHeight="100vh" minWidth={0}>
          <Header />
          <ContentBox
            component="main"
            id="main-content"
            tabIndex={-1}
            sx={
              compactTop
                ? { pt: { mobile: "12px", tablet: "16px" } }
                : undefined
            }
          >
            <Outlet />
          </ContentBox>
        </Stack>
      </Box>
    </Box>
  )
}

export default BaseLayout
